import {
    GET_ALL_JOB_POSITIONS,
    GET_JOB_POSITION_LIST,
    LOADING_JOB_POSITION_LIST,
    START_ADD_JOB_POSITION,
    START_REMOVE_JOB_POSITION,
    START_UPDATE_JOB_POSITION,
    STOP_ADD_JOB_POSITION, STOP_REMOVE_JOB_POSITION,
    STOP_UPDATE_JOB_POSITION
} from "../types";
import {httpWrapper} from "../../libs/http";

export const fetchJobPositionList = (page = null, perPage = null, param = null) => {
    return async dispatch => {
        try {
            dispatch({
                type: LOADING_JOB_POSITION_LIST
            })

            let uri = '/job_positions?'
            if(page && perPage){
                uri = uri + `page=${page}&limit=${perPage}`;
            }

            if(param){
                uri = param.param ? uri + `&${param.typeParam}=${param.param}` : uri;
            }

            const response = await httpWrapper(uri, {credentials: "include", mode: "cors"});
            if(!response.ok){
                let error = await response.json()
                throw new Error(error.message)
            }
            const result = await response.json()

            dispatch({
                type: GET_JOB_POSITION_LIST,
                payload: result
            })

        }catch (e){

            throw new Error(e.message)

        }
    }
}

export const fetchAllJobPositions = () => {
    return async dispatch => {
        try {
            dispatch({
                type: LOADING_JOB_POSITION_LIST
            })

            const response = await httpWrapper('/job_positions', {credentials: "include", mode: "cors"});
            if(!response.ok){
                let error = await response.json()
                throw new Error(error.message)
            }
            const result = await response.json()

            dispatch({
                type: GET_ALL_JOB_POSITIONS,
                payload: result
            })
        } catch (e) {
            throw new Error(e.message)
        }
    }
}

export const addJobPosition = (data) => {
    return async dispatch => {
        try {
            dispatch({
                type: START_ADD_JOB_POSITION
            })
            const response = await httpWrapper('/job_positions', {
                method: 'post',
                credentials: "include", mode: "cors",
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(data)
            });
            if(!response.ok){
                let error = await response.json()
                throw new Error(error.message)
            }
            const result = await response.json()
            dispatch({
                type: STOP_ADD_JOB_POSITION
            })
        } catch (e) {
            throw new Error(e.message)
        }
    }
}

export const updateJobPosition = (data, strCode) => {
    return async dispatch => {
        try {
            dispatch({
                type: START_UPDATE_JOB_POSITION
            })
            const response = await httpWrapper(`/job_positions/${strCode}`, {
                method: 'put',
                credentials: "include", mode: "cors",
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(data)
            });
            if(!response.ok){
                let error = await response.json()
                throw new Error(error.message)
            }
            const result = await response.json()
            dispatch({
                type: STOP_UPDATE_JOB_POSITION
            })
        } catch (e) {
            throw new Error(e.message)
        }
    }
}

export const removeJobPosition = (strCode) => {
    return async dispatch => {
        try {
            dispatch({
                type: START_REMOVE_JOB_POSITION
            })
            const response = await httpWrapper(`/job_positions/${strCode}`, {
                method: 'delete',
                credentials: "include", mode: "cors"
            });
            if(!response.ok){
                let error = await response.json()
                throw new Error(error.message)
            }
            const result = await response.json()
            dispatch({
                type: STOP_REMOVE_JOB_POSITION
            })
        } catch (e) {
            throw new Error(e.message)
        }
    }
}